import AddCareer from "../../Components/Modals/AddCareer";
import Table from "../../Components/Table";
import { deleteCareerById, deleteCityById, getAllCareer } from "../../Services/MasterService";

const Career = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Status",
            value: "status_name"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCareer data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCareer}
            columns={columns}
            title={"Career Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCareerById}
        />
    );
}

export default Career;